"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocApprovedPositive = function SvgBDocApprovedPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M59.281 40.267H23.658a2.262 2.262 0 110-4.523h35.623a2.262 2.262 0 010 4.523zM84.229 54.509h-60.57a2.262 2.262 0 110-4.524h60.57a2.262 2.262 0 010 4.524zM84.229 68.758h-60.57a2.262 2.262 0 010-4.523h60.57a2.262 2.262 0 110 4.523zM84.229 83h-60.57a2.262 2.262 0 010-4.524h60.57a2.262 2.262 0 110 4.524z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M2.262 100.687A2.262 2.262 0 010 98.425V27.24a2.262 2.262 0 012.262-2.261H24.97v-11.98a2.262 2.262 0 014.524 0v14.241a2.262 2.262 0 01-2.262 2.262H4.524v68.924a2.262 2.262 0 01-2.262 2.262z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M102.723 117.386a2.262 2.262 0 01-1.606-.663l-7.886-7.894a2.262 2.262 0 013.196-3.196l6.296 6.287 19.096-19.097a2.263 2.263 0 013.197 3.205l-20.695 20.695a2.262 2.262 0 01-1.598.663z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M105.746 143.593H5.888A5.888 5.888 0 010 137.705V40.07a2.262 2.262 0 114.524 0v97.634c0 .753.61 1.364 1.364 1.364h97.596v-9.861a2.262 2.262 0 014.524 0v12.123a2.262 2.262 0 01-2.262 2.262z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M105.753 131.447a2.262 2.262 0 010-4.523c9.973-.034 18.248-7.721 19.014-17.665v-.234a2.266 2.266 0 114.524.272v.271c-.929 12.31-11.171 21.832-23.515 21.864l-.023.015zM95.244 128.703a2.262 2.262 0 01-1.109-.294c-10.853-6.079-15.132-19.533-9.784-30.764 5.348-11.231 18.49-16.39 30.05-11.795a2.262 2.262 0 01-1.666 4.207c-9.346-3.713-19.97.458-24.293 9.538-4.324 9.08-.864 19.956 7.91 24.87a2.262 2.262 0 01-1.108 4.238z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M105.625 75.822a2.262 2.262 0 01-2.262-2.261l.046-67.854c0-.666-.54-1.206-1.207-1.206H24.653L10.977 18.2a2.262 2.262 0 01-3.196-3.197L22.105.68A2.26 2.26 0 0123.72 0h78.483a5.737 5.737 0 015.73 5.73l-.045 67.853a2.262 2.262 0 01-2.262 2.24z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M2.262 143.45A2.262 2.262 0 010 141.188V27.14a2.262 2.262 0 012.262-2.261h22.67V12.952a2.262 2.262 0 014.524 0v14.19a2.262 2.262 0 01-2.262 2.261H4.524v111.785a2.262 2.262 0 01-2.262 2.262z",
    fill: "#285"
  })));
};

var _default = SvgBDocApprovedPositive;
exports["default"] = _default;